<template>
    <div ref="tooltip"
         class="btn-hint"
         :data-pt-title="text"
         data-pt-size="small"
         data-pt-classes="protip"
         data-pt-scheme="black"
         data-pt-gravity="true"
         data-pt-position="top"
         data-pt-offset-left="20">
        <i class="fa fa-info-circle"></i>
    </div>
</template>

<script type="text/babel">
export default {
    name: 'tooltip',

    props: {
        text: {
            type: String,
            required: true
        }
    },

    mounted () {
        $(this.$refs.tooltip).protipSet();
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/tooltip/tooltip.component.vue